import React from "react";
import { Button, Container, Image } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import ResponsiveModal from "@/components/ui/responsiveModal";
import ConfirmDelete from "@/../public/images/icons/confirm-delete.svg";
import styles from "@/components/ui/responsiveModal/responsiveModal.module.scss";

interface ConfirmDeleteModalProps {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => void;
}

const ConfirmDeleteModal: React.FC<ConfirmDeleteModalProps> = ({
  isOpen,
  onClose,
  onConfirm,
}) => {
  const { t } = useTranslation();

  return (
    <ResponsiveModal
      isOpen={isOpen}
      onClose={onClose}
      headerLeft={<></>}
      bodyClassName="p-0"
      footerClassName={styles.footerShadow}
      footer={
        <div className="w-100 d-flex flex-column flex-md-row gap-4 m-0">
          <Button
            type="button"
            variant="outline-primary"
            className="flex-fill order-2 order-md-1"
            onClick={onClose}
          >
            {t("Cancel")}
          </Button>
          <Button
            type="button"
            variant="primary"
            className="flex-fill order-1 order-md-2"
            onClick={onConfirm}
          >
            {t("Delete")}
          </Button>
        </div>
      }
    >
      <Container
        fluid
        className="px-5 px-md-4 d-flex flex-column justify-content-center align-items-center h-100"
      >
        <div className="d-flex justify-content-center mb-5 mb-md-4">
          <Image
            src={ConfirmDelete}
            alt={t("Confirm delete")}
            className="d-block d-md-none"
            style={{ width: 177, height: 129, objectFit: "contain" }}
          />

          <Image
            src={ConfirmDelete}
            alt={t("Confirm delete")}
            className="d-none d-md-block"
            style={{ width: 175, height: 144, objectFit: "contain" }}
          />
        </div>

        <h5 className="fs-24 fw-bold mb-1 mb-md-2">{t("Delete product?")}</h5>
        <p
          className="fs-16 text-grey-text m-0 text-center"
          style={{ maxWidth: 300 }}
        >
          {t(
            "Would you like to remove this product from your selection (cart)?"
          )}
        </p>
      </Container>
    </ResponsiveModal>
  );
};

export default React.memo(ConfirmDeleteModal);
